import script from "./UiPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiPagination.vue?vue&type=script&setup=true&lang=ts"

import "./UiPagination.vue?vue&type=style&index=0&id=73d4ee74&scoped=true&lang=sass"

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d4ee74"]])

export default __exports__